import styled from '@emotion/styled';

export const CardFooter = styled.div`
    border-top: ${({ theme }) => `1px solid ${theme.colors.accent}`};
    padding: 16px ${({ theme }) => theme.card.padding}px;
`;

